<template>
  <div class="main">
    <Header
      :show="true"
      :title="docTitle"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
    />
    <div style="padding-bottom: 8vh">
      <el-table
        v-loading="loading"
        size="small"
        :data="visibleData ? visibleData.stockDetailList : []"
        style="width: 100%"
      >
        <el-table-column
          label="序号"
          type="index"
          width="60"
        />
        <el-table-column
          label="申领物品"
          prop="materialsName"
          show-overflow-tooltip
          width="100"
        />
        <el-table-column
          label="所在位置"
          prop="stockInfo"
          show-overflow-tooltip
        />
        <el-table-column
          label="状态"
          prop="status"
          width="80"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.applyStatus === '0'"
              size="small"
              type="info"
            >
              未出库
            </el-tag>
            <el-tag
              v-if="row.applyStatus === '1'"
              size="small"
              type="success"
            >
              已出库
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Footer
      :show="false"
      value="service"
    />
  </div>
</template>

<script>
import { findById } from "@/api/wms/outStock";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

export default {
  components: {
    Header,
    Footer,
  },
  data: () => ({
    loading: false,
    visibleData: undefined,
    docTitle: "",
  }),
  computed: {},
  created() {
    const row = this.$route.query;
    this.searchItem(row.id);
    this.docTitle = row.sn;
  },
  methods: {
    handleClickLeft() {
      this.$router.go(-1);
    },
    async searchItem(id) {
      this.loading = true;
      const { data } = await findById(id).finally(() => (this.loading = false));
      if (data.code === 2000) {
        this.visibleData = data.data;
      }
    },
    submit() {},
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
